<template>
  <section class="hero" :style="{ '--background-color': template.backgroundColor, '--text-color': template.textColor, '--highlight-color': template.highlightColor }">
    <div class="hero-background">
      <img class="background-image" :src="template.backgroundImage" alt />
    </div>
    <div class="hero-text-box">
      <h1 class="event-title" v-html="template.title"></h1>
      <h2 class="event-subtitle" v-html="template.subtitle"></h2>
      <a class="btn btn-full" href="#" @click.prevent="takeAction">{{ template.cta }}</a>
      <br />
      <h3 class="event-date">{{ template.date }}</h3>
    </div>
  </section>
</template>
<script>
import api from '@/services/api';

export default {
  name: 'Hero',

  data() {
    return {
      template: null,
      activity: '',
    };
  },

  methods: {
    takeAction() {
      switch (this.template.action.type) {
        case 'url':
          //this.$router.push(this.template.action.url);
          window.open(this.template.action.url);
          break;

        default:
          this.$router.push({
            name: this.template.action.type,
            params: {
              stream: this.template.action.url,
            },
          });
          break;
      }
    },
  },

  beforeMount() {
    this.template = this.$store.state.template.home.hero;

    api
      .get(`event/${this.$store.state.eventId}/activities`)
      .then((response) => {
        //console.log('activities', response);
        this.activity = response.data.length ? response.data[0].activity_id : '';
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>
<style lang="scss">
.hero {
  position: relative;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: var(--main-color);
}

.hero-background {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: var(--background-color);

  .background-image {
    z-index: 1;
    position: relative;
    height: 100%;
    flex-grow: 1;
    flex-shrink: 0;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background-image: linear-gradient(to left, var(--main-color), var(--highlight-color));
    z-index: 0;
  }
}
.hero-text-box {
  z-index: 2;
  position: relative;
  width: 90%;
  padding-left: 5%;
}
.event-title {
  z-index: 2;
  color: var(--text-color, #fff);
  font-weight: 400;
  font-size: 3.5rem;

  strong {
    z-index: 2;
    color: var(--highlight-color, #fff);
  }
}
.event-subtitle {
  z-index: 2;
  font-size: 1.4rem;
  word-spacing: 2px;
  margin-bottom: 50px;
  letter-spacing: 1px;
  color: var(--text-color);
}
.event-date {
  z-index: 2;
  display: inline-block;
  margin-top: 50px;
  font-size: 150%;
  border-bottom: 2px solid var(--main-color);
  padding-bottom: 20px;
  color: var(--highlight-color);
}

/*---------- 
  BREAKPOINT 
  ----------*/
@include media('<=tablet') {
  .hero-background {
    justify-content: center;
    align-items: flex-end;
  }

  .hero-text-box {
    margin-top: 20%;
  }
  .event-subtitle {
    font-size: 1.5rem;
  }
}
</style>
